module.exports = __webpack_public_path__ + "img/GT.DeepFoundation.BoredPile.InSituConcreteRotaryBoredPileSingle900dia.68928afd.png";